export default __webpack_public_path__ + "static/media/MP0034.c421cb35.jpg";